import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { SocialLink } from '@bd/bdcore-utilities';
import ContactModal from './ContactModal';
import { colors, typography } from '../styles';

const styles = css`
  padding:0 0 60px 0;
  border-top:4px solid ${colors.color2};
  color:white;
  background: ${colors.color1};
  margin-top: 200px;
  @media (min-width: 768px) {
    padding:0 40px 60px 40px;
  }

  .FooterInfo {
    display: flex;
    flex-flow:row wrap;
    justify-content: space-between;
  }
  .FooterInfo-Contact {
    font:300 16px/32px ${typography.SansSerif};
    width:100%;
    text-align:center;
    @media (min-width: 768px) {
      width:50%;
      text-align: left;
    }

    .FooterInfo-Contact-heading {
      font:700 18px/32px ${typography.SansSerif};
      text-transform: uppercase;
    }
    ul {
      margin:0;
    }
    a {
      color:${colors.color2};
      font-weight:900;
    }
  }
  .FooterInfo-SocialLinks {
    width:100%;
    padding-top:30px;
    text-align: center;
    @media (min-width: 768px) {
      width:50%;
      padding:0;
      text-align: right;
    }
    ul {
      padding:0;
      list-style-type: none;
      display:flex;
      flex-flow: row nowrap;
      justify-content: center;
      margin:0;
      @media (min-width: 768px) {
        justify-content: flex-end;
      }
      li {
        margin:0 0 10px 10px;
        border:1px solid #ddd;
        width:46px;
        height:46px;
        display: flex;
        flex-flow:column nowrap;
        justify-content: center;

        a {
          text-align: center;
        }
      }
    }
  }
  .FooterRequired {
    display: flex;
    flex-flow:row wrap;
    justify-content: space-between;
    background: ${colors.color1};
    color:white;
    padding:40px;
    a {
      color:white;
    }
  }
  .FooterRequired-Plug, .FooterRequired-Copyright {
    font:300 16px/32px ${typography.SansSerif};
    width:100%;
    @media (min-width: 768px) {
    }
  }
  .FooterRequired-Copyright {
    text-transform: uppercase;
  }
  .FooterRequired-Plug {

    @media (min-width: 768px) {
      text-align: right;
    }

    a {
      color:${colors.color2};
      font-weight:700;
    }
  }
  .ContactSection-Wrapper {
    margin-top:-140px;
    margin-bottom:60px;
  }
  .ContactSection {
    background: ${colors.color2};
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    padding:40px 20px;
    color:white;
    @media (min-width: 768px) {
      padding:40px;
    }
  }
  .ContactSection_Content {
    width:100%;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-bottom:1px solid white;
    padding-bottom:10px;
    @media (min-width: 991px) {
      width:50%;
      align-items: flex-start;
      text-align: left;
      padding:0 40px 0 0;
      border-bottom:0;
      border-right:1px solid white;
    }
  }
  .ContactSection_Action {
    width:100%;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    @media (min-width: 991px) {
      width:50%;
      align-items: flex-start;
      text-align: left;
      padding-left:40px;
    }
  }
  .ContactSection_Heading {
    font:900 30px/1.2 ${typography.SansSerif};
    color:white;
    text-transform: uppercase;
    @media (min-width: 991px) {
      font:900 48px/1.2 ${typography.SansSerif};
    }
  }

  .BtnSet {
    margin:20px auto 0 auto;
    display: flex;
    flex-flow:row nowrap;
    justify-content: space-around;
    width:100%;
    max-width: 500px;
    @media (min-width: 991px) {
      margin:20px auto;
    }
    .BtnSet-icon {
      width:46%;
      padding-top:46%;
      background:${colors.color2Darker};
      position:relative;
      border-radius:50%;
      @media (min-width: 480px) {
        width:40%;
        padding-top:40%;
      }
      .BtnSet-iconInner {
        position:absolute;
        top:0;
        right:0;
        bottom:0;
        left:0;
        display:flex;
        flex-flow:column nowrap;
        justify-content: center;
        text-align: center;
        color:white;
        font-size:12px;
        @media (min-width: 991px) {
          font-size:14px;
        }
        img {
          width:36px;
          height:30px;
          margin:0 auto;
          fill:red;
          margin-bottom:5px;
          @media (min-width: 991px) {
            width:48px;
            height:40px;
          }
        }
      }
    }
  }
`;

function Footer({ builder, widget }) {
  return (
    <div className={styles}>
      <div className="container ContactSection-Wrapper">
        <div className="ContactSection">
          <div className="ContactSection_Content">
            <h3 className="ContactSection_Heading">{get(widget, 'contact_section[0].headline')}</h3>
            <p className="ContactSection_Description">{get(widget, 'contact_section[0].description')}</p>
          </div>
          <div className="ContactSection_Action">
            <ul className="BtnSet list-unstyled">
              <li className="BtnSet-icon">
                <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="BtnSet-iconInner"><img src="/images/icon-phone-white.svg" alt="" />{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
              </li>
              {/* <li className="BtnSet-icon">
                <a href={`sms:${get(builder, 'text_phone').replace(/[^0-9]/g, '')}`}
                 className="BtnSet-iconInner"><img src="/images/icon-sms-white.svg"
                  alt="" />TEXT</a>
              </li> */}
              <li className="BtnSet-icon">
                <ContactModal>
                  <div className="BtnSet-iconInner"><img src="/images/icon-email-white.svg" alt="" />EMAIL</div>
                </ContactModal>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="FooterInfo">
        <div className="FooterInfo-Contact">
          <ul className="list-unstyled">
            <li className="FooterInfo-Contact-heading">{builder.name}</li>
            <li>{builder.address.streetAddress}</li>
            <li>{`${builder.address.addressLocality}, ${builder.address.addressRegion} ${builder.address.postalCode}`}</li>
            <li><strong><a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="FooterLink">{get(builder, 'telephone').replace(/\s-\s/, '-')}</a></strong></li>
          </ul>
        </div>
        <div className="FooterInfo-SocialLinks">
          <ul className="list-unstyled">
            {
                get(builder, 'socialLinks', []).map(link => (
                  <li key={link}>
                    <SocialLink
                      url={link}
                    />
                  </li>
                ))
              }
          </ul>
          <div className="FooterRequired-Copyright">
            ©{(new Date()).getFullYear()} {builder.name}.
          </div>
          <div className="FooterRequired-Plug">
            Site by: <a href="https://builderdesigns.com"><strong className="FooterLink" target="_blank">Builder Designs</strong></a>
          </div>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  widget: 'footer',
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js